import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AddNotes } from "./addNotes";
import { ButtonMain, PageLoader } from "components";
import { FindLoad, usePrimaryModal } from "utils";
import { noteActions } from "store";
import { Svg } from "assets";
import { NoteCard } from "./noteCard";

const ACTION_TYPE = "GET_GLOBAL_NOTES";

export const Notes = ({ onResource, currentId }) => {
  const { notesList } = useSelector((state) => ({
    notesList: state.notes.notesList,
  }));
  const dispatch = useDispatch();
  const loading = FindLoad(ACTION_TYPE);
  const { openPrimary } = usePrimaryModal();

  useEffect(() => {
    dispatch(noteActions.getGlobalNotes(currentId));
  }, [dispatch]);

  const handleAddNote = () => {
    openPrimary(<AddNotes onResource={onResource} currentId={currentId} />, {
      noShowCloseBtn: true,
      padding: "noPaddings",
      maxWidth:1276,
    });
  };

  return (
    <div className="notes-wrapper">
      {loading ? (
        <PageLoader wrapperHeight="100%" height="100%" />
      ) : notesList?.length ? (
        <div className="notes-box">
          {notesList?.map((note) => (
            <NoteCard
              item={note}
              currentId={currentId}
              onResource={onResource}
            />
          ))}
        </div>
      ) : (
        <div className="notes-empty-wrapper">
          <div className="notes-empty-box">
            <Svg.NotesEmptySvg />

            <p className="notes-empty-title">No notes available!</p>

            <p className="notes-empty-desc">
              You haven’t added any notes yet. Click{" "}
              <span style={{ fontWeight: 600 }}>“Add Note”</span> to get
              started.
            </p>

            <ButtonMain
              text="Add Note"
              onClick={handleAddNote}
              small
              buttonMainStyles={{
                width: "fit-content",
                padding: "6px 12px",
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};
